// extracted by mini-css-extract-plugin
export default {"bottom":"bottom__2B13G","contentContainer":"contentContainer__3Xr3F","heading":"heading__3xlGi"};